import { useQuery } from '@tanstack/react-query';

import { getAnvaEmployees, type GetAnvaEmployeesResponse } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useAnvaEmployees(
  options?: QueryOptions<GetAnvaEmployeesResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.employees.list('anva', undefined),
    queryFn: async () => {
      const result = await getAnvaEmployees({}, wgApi);

      return result.items;
    },
    ...options,
  });
}
